module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/tr/address/postcode.js
// module id = 1777
// module chunks = 1